
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'ProductInner',
  props: {
    programBlock: {
      type: Object,
      required: true
    },

    refreshTab: {
      type: Function,
      required: true
    },

    selectedBlockId: {
      type: [String, Number],
      required: true
    },

    isHideCompleted: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      i18n: 'pages.education.courses-list'
    }
  },

  computed: {
    ...mapState(['attendees', 'courses', 'quarters', 'notifications']),

    allCoursesNotifications() {
      return this.notifications?.[this.selectedBlockId]?.courses
    },

    productAttendees() {
      const { programBlock } = this
      if (Array.isArray(programBlock?.content)) {
        let attendees = programBlock.content.map(
          course => this.attendees[course]
        )
        if (this.isHideCompleted) {
          attendees = attendees.filter(course => !course.completed)
        }

        return attendees
      }

      const content = programBlock.content

      if (content?.attendees && content?.courses) {
        let attendees = content.attendees.map(course => this.attendees[course])
        if (this.isHideCompleted) {
          attendees = attendees.filter(course => !course.completed)
        }
        const courses = content.courses.map(course => {
          const newCourse = this.courses[course]
          newCourse.isCourse = true

          return newCourse
        })

        return [...attendees, ...courses]
      }

      if (content) {
        const allContentValues = Object.values(content).flat()

        return allContentValues.map(course => this.attendees[course])
      }

      return []
    },

    isNotActive() {
      // BACKEND хорошо бы что бы они просто не приходили с бека
      return this.programBlock.type !== 'active'
    },

    checkedSelectedBlockIdType() {
      return typeof this.selectedBlockId === 'number'
        ? this.selectedBlockId
        : NaN
    },

    information() {
      const { programBlock } = this
      if (programBlock?.quarter) {
        const quarter = this.quarters[programBlock?.quarter]

        if (quarter?.description) {
          return {
            title: quarter.title,
            description: quarter.description
          }
        } else {
          return null
        }
      } else if (
        programBlock?.contentType === 'supplements' ||
        programBlock?.contentType === 'electives'
      ) {
        return {
          title: this.$t(`${this.i18n}.${[programBlock.contentType]}.title`),
          description: this.$t(
            `${this.i18n}.${[programBlock.contentType]}.description`
          )
        }
      }

      return null
    },

    isDescription() {
      return (
        this.information ||
        this.programBlock?.contentType === 'supplements' ||
        this.programBlock?.contentType === 'electives'
      )
    },

    isGuStreamList() {
      return this.programBlock.contentType === 'guStreamLists'
    },

    isSupplement() {
      return this.programBlock.type === 'supplements'
    }
  },

  methods: {
    courseNoticeId(courseId) {
      return this.allCoursesNotifications?.[courseId]?.id
    },

    async readCourseNotification(id) {
      const noticeId = this.courseNoticeId(id)

      if (noticeId) {
        const response = await this.$store.dispatch(
          'education/removeNotice',
          noticeId
        )

        if (response === 'ok') {
          this.$store.commit('education/deleteNotificationCourse', {
            productAttendeeId: this.selectedBlockId,
            id
          })
        }
      }
    }
  }
}
